import React from 'react'
import Navbvar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import ContactSection from '../../components/pages/Contact/ContactSection'

const Contact = () => {
  return (
    <div>
        <Navbvar />
        <ContactSection />
        <Footer/>
    </div>
  )
}

export default Contact